var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.858 11.9999V14.2856C10.858 14.5887 10.7376 14.8794 10.5232 15.0937C10.3089 15.308 10.0182 15.4284 9.71512 15.4284H1.71512C1.41202 15.4284 1.12133 15.308 0.907001 15.0937C0.692673 14.8794 0.572266 14.5887 0.572266 14.2856V1.71415C0.572266 1.41104 0.692673 1.12035 0.907001 0.906024C1.12133 0.691697 1.41202 0.571289 1.71512 0.571289H9.71512C10.0182 0.571289 10.3089 0.691697 10.5232 0.906024C10.7376 1.12035 10.858 1.41104 10.858 1.71415V3.99986",
    stroke: "#3E3E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42969 8H15.4297",
    stroke: "#3E3E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1445 5.71387L15.4302 7.99958L13.1445 10.2853",
    stroke: "#3E3E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.d5928b3f396fd3d0b37648530606b122.svg";
export { ForwardRef as ReactComponent };